(() => {
  const stylesheet = document.getElementById('pt-collection-icon-css');
  if (!stylesheet || stylesheet.hasAttribute('href')) return;

  const selector = '.fa,.fas,.far,.fab,.fal,.fat,.fad,.fass,.fasr,.fasl,.fast,[class^="fa-"],[class*=" fa-"]';
  let scheduled = false;
  const check = () => {
    scheduled = false;
    if (!document.querySelector(selector)) return false;
    observer.disconnect();
    stylesheet.href = stylesheet.dataset.href;
    return true;
  };
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(check, 250);
  });
  let started = false;
  const wakeEvents = ['pointerdown', 'focusin'];
  const start = () => {
    if (started) return;
    started = true;
    wakeEvents.forEach(event => document.removeEventListener(event, start, true));
    if (!check()) {
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  };
  const startWhenIdle = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1000 });
    else setTimeout(start, 0);
  };
  wakeEvents.forEach(event => document.addEventListener(event, start, { capture: true, passive: true }));
  if (document.readyState === 'complete') startWhenIdle();
  else window.addEventListener('load', startWhenIdle, { once: true });
})();
